import React, { useState } from "react";
import { UnoStoreHooks } from "@simulanisindia/ui";
import { Navigate, Route, Routes } from "react-router-dom";
import { routes } from '../routes/routes';

const { useUnoSelector } = UnoStoreHooks;

const Layout = () => {
  const [sideBar, setSideBar] = useState(false);
  const userData = useUnoSelector((state) => state.user);
  const isLoggedIn = userData?.token ? true : false;
  const defaultRoute = isLoggedIn ? "/dashboard/directories" : "/gateway";
  const routesToDisplay = (isLoggedIn ? routes.private : routes.public) || [];

  return (
    <Routes>
      {routesToDisplay.map((route) => {
        const LayoutToRender = route.layout;
        const ElementToRender = route.elem;
        return (
          <Route
            key={route.path}
            path={route.path}
            element={
              <LayoutToRender sideBar={sideBar} setSideBar={setSideBar}>
                <ElementToRender />
              </LayoutToRender>
            }
          />
        );
      })}
      <Route path="*" element={<Navigate to={defaultRoute} />} />
    </Routes>
  );
};

export default Layout;
